module.exports = __webpack_public_path__ + "img/help.a5be22cb.svg";